// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-6ab93c18] .invoice-overview .card-header,[data-v-6ab93c18] .invoice-overview .card-footer {\n  border: none;\n}\n", ""]);
// Exports
module.exports = exports;
